import {
	type EasyMatchStartInputBody,
	type EasyMatchStatusResponse,
	type EasyPendingFeedback,
	easyMatchConfirm,
	easyMatchFeedback,
	easyMatchFeedbackSkip,
	easyMatchSkip,
	easyMatchStart,
	type MatchResultBody,
	getEasyMatchStatus as requestEasyMatchStatus,
} from "@/shared/api/generated-social"

export type EasyMatchStatus = EasyMatchStatusResponse
export type EasyMatchPendingFeedback = NonNullable<EasyPendingFeedback>

export async function confirmEasyMatch(
	userRelationshipId: number,
): Promise<MatchResultBody["result"]> {
	const { result } = await easyMatchConfirm({
		body: {
			user_relationship_id: userRelationshipId,
		},
	})
	return result
}

export async function getEasyMatchStatus(): Promise<EasyMatchStatus> {
	return requestEasyMatchStatus()
}

export type GenderPreference = EasyMatchStartInputBody["gender_preference"]

export async function requestEasyMatch(
	userId: number,
	genderPreference: GenderPreference,
) {
	await easyMatchStart({
		body: {
			user_id: userId,
			gender_preference: genderPreference,
		},
	})
}

// Пропуск текущего кандидата + запуск следующего поиска (бывший skip: true).
// expired = кандидат уже истёк, следующий поиск бэк при этом не запускает;
// ветки в UI нет (юзер и так уходит на хоум).
export async function skipEasyMatch(
	userId: number,
	genderPreference: GenderPreference,
	userRelationshipId: number,
) {
	await easyMatchSkip({
		body: {
			user_id: userId,
			gender_preference: genderPreference,
			user_relationship_id: userRelationshipId,
		},
	})
}

export async function submitEasyMatchFeedback(args: {
	requestId: string
	rating: number
	comment: string
}): Promise<EasyMatchStatus> {
	return easyMatchFeedback({
		body: {
			request_id: args.requestId,
			rating: args.rating,
			comment: args.comment,
		},
	})
}

export async function skipEasyMatchFeedback(
	requestId: string,
): Promise<EasyMatchStatus> {
	return easyMatchFeedbackSkip({
		body: { request_id: requestId },
	})
}
